import { GuardedComponent } from '../components/guarded-component';
import AuditLogPage from '../features/masters/audit-log/audit-log.page';
import { UserPermissionName } from '../models/user-permission-name';

export const AuditLogRoute = {
  path: '/audit-log',
  name: 'Audit Log',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_AUDITLOG]} showPermissionError>
          <AuditLogPage />
        </GuardedComponent>
      ),
    },
  ],
};
